module.exports = __webpack_public_path__ + "img/owow.4ebb34a7.svg";